export default import.meta.ROLLDOWN_FILE_URL_dHDMO0dtqgUZCr4yokXpXA